// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-validator-has-errors {
  border: 1px solid red !important;
}

.fi-tooltip-content.fi-content-validator-tooltip-content {
  z-index: 2100 !important;
  animation: content-validator-error-tooltip-keyframes 1.5s 0.7s ease-in-out;
}
.fi-tooltip-content.fi-content-validator-tooltip-content.prevent-tooltip-overflow-dialog {
  z-index: 200 !important;
}

@keyframes content-validator-error-tooltip-keyframes {
  0% {
    transform: translate(0px, 0px);
    animation-timing-function: ease-in-out;
  }
  25% {
    transform: translate(20px, 0px);
    animation-timing-function: ease-in-out;
  }
  50% {
    transform: translate(0px, 0px);
    animation-timing-function: ease-in-out;
  }
  75% {
    transform: translate(15px, 0px);
    animation-timing-function: ease-in-out;
  }
  100% {
    transform: translate(0px, 0px);
    animation-timing-function: ease-in-out;
  }
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-tooltip/fi-content-validator-tooltip/fi-content-validator-tooltip.component.scss"],"names":[],"mappings":"AAAA;EACI,gCAAA;AACJ;;AAEA;EACI,wBAAA;EACA,0EAAA;AACJ;AAAI;EACI,uBAAA;AAER;;AAEA;EACI;IACI,8BAAA;IACA,sCAAA;EACN;EACE;IACI,+BAAA;IACA,sCAAA;EACN;EACE;IACI,8BAAA;IACA,sCAAA;EACN;EACE;IACI,+BAAA;IACA,sCAAA;EACN;EACE;IACI,8BAAA;IACA,sCAAA;EACN;AACF","sourcesContent":[".content-validator-has-errors {\r\n    border: 1px solid red !important;\r\n}\r\n\r\n.fi-tooltip-content.fi-content-validator-tooltip-content {\r\n    z-index: 2100 !important;\r\n    animation: content-validator-error-tooltip-keyframes 1.5s 0.7s ease-in-out;\r\n    &.prevent-tooltip-overflow-dialog {\r\n        z-index: 200 !important;\r\n    }\r\n}\r\n\r\n@keyframes content-validator-error-tooltip-keyframes {\r\n    0% {\r\n        transform: translate(0px, 0px);\r\n        animation-timing-function: ease-in-out;\r\n    }\r\n    25% {\r\n        transform: translate(20px, 0px);\r\n        animation-timing-function: ease-in-out;\r\n    }\r\n    50% {\r\n        transform: translate(0px, 0px);\r\n        animation-timing-function: ease-in-out;\r\n    }\r\n    75% {\r\n        transform: translate(15px, 0px);\r\n        animation-timing-function: ease-in-out;\r\n    }\r\n    100% {\r\n        transform: translate(0px, 0px);\r\n        animation-timing-function: ease-in-out;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
